export default __webpack_public_path__ + "static/media/linkedin2.005f026c.svg";